import axios from "axios";
// import { setAlert } from './alert';
import {
  REPORT_USER,
  GET_REPORTED_USERS,
  DELETE_REPORT,
  REPORT_USER_ERROR,
} from "./types";

// Report a user
export const reportUser =
  (text, image, video, channelid, isCurrent, reportedText, profile_id, gif) =>
  async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const formData = new FormData();
    formData.append("text", JSON.stringify(text));
    formData.append("image", JSON.stringify(image));
    formData.append("video", JSON.stringify(video));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("option", JSON.stringify(isCurrent));
    formData.append("reportedText", JSON.stringify(reportedText));
    formData.append("profile_id", JSON.stringify(profile_id));
    formData.append("gif", JSON.stringify(gif));

    try {
      const res = await axios.post(`/api/report`, formData, config);

      dispatch({
        type: REPORT_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: REPORT_USER_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Get reports
export const getReports = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/report/reports`);

    dispatch({
      type: GET_REPORTED_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: REPORT_USER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete report
export const deleteReport = (id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const formData = new FormData();
  formData.append("id", JSON.stringify(id));

  try {
    const res = await axios.post(`/api/report/delete_report`, formData, config);

    dispatch({
      type: DELETE_REPORT,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: REPORT_USER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
